import FirestoreDocument from "../../../types/FirestoreDocument";
import {
	any,
	array,
	currency,
	distributor,
	enumValues,
	language,
	nullable,
	number,
	object,
	record,
	string,
	timestamp,
} from "../../../types/_types";

import articleTypes from "../../articles/constants/articleTypes";
import { articleType } from "../../articles/types/Article";
import { DistributionPreset } from "../../distribution/types/DistributionPreset";
import { PipelineSettings } from "../../distribution/types/PipelineSettings";
import { Vendors } from "../../vendors/types/Vendor";

import organizationTypes from "../constants/organizationTypes";

export const organizationType = enumValues(organizationTypes);

export const Organization = FirestoreDocument.extend({
	adminUserIds: array(string()),
	contractHolderName: nullable(string()),
	currencyDefault: nullable(currency()),
	currencyOptions: array(currency()),
	distributors: array(distributor()),
	distribution: object({
		presets: record(string(), DistributionPreset),
		channels: record(string(), PipelineSettings),
	})
		.partial()
		.default({}),
	exportPresets: record(string(), PipelineSettings).default({}),
	automaticDistributionTypes: array(articleType).default([
		articleTypes.AUDIOBOOK,
		articleTypes.PODCAST,
		articleTypes.EBOOK,
	]),
	languageDefault: language(),
	languageOptions: array(language()),
	name: string(2),
	type: organizationType,
	vendors: Vendors.default({}),
	featureFlags: array(string()),
	financeEmail: string().optional(),
	finance: object({ scheduledOrdersDate: number().or(string()).nullable() })
		.partial()
		.passthrough()
		.optional(),
	invoiceFooter: string().optional(),
	studioSettings: object({ compression: record(string(), number().or(string())) })
		.partial()
		.passthrough()
		.optional(),
	prices: record(string(), record(string(), any())).optional(),
	publishers: array(string(), false).optional(),
	producerIds: array(string(), false).optional(),
	producerType: string().optional(),
	currencies: array(string(), false).optional(),
	currencyReaderSettings: record(string(), any()).optional(),
	productionMeta: record(string(), any()).optional(),
	blurbs: record(string(), any()).optional(),
	distributionOptions: record(string(), any()).optional(),
	reaperTemplates: object({ list: array(string(), false), master: string() })
		.partial()
		.passthrough()
		.optional(),
	// Start fees are charged for works created from this date, and not at all while unset.
	cloudStartFeesFrom: nullable(timestamp()),
});
